import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {IParticipant} from '@interfaces/interfaces';

@Injectable({
	providedIn: 'root'
})
export class ParticipantRestService {

	constructor(private httpClient: HttpClient) { }

	listParticipants$(projectID: number|string, extendWorkflow?: boolean): Observable<IParticipant[]> {
		const url = extendWorkflow ? `${environment.serverEndpoint}/api/projects/${projectID}/participants?extendedWorkflow=true` : `${environment.serverEndpoint}/api/projects/${projectID}/participants`;
		return this.httpClient.get<IParticipant[]>(url);
	}

	async listParticipants(projectID: number|string, extendWorkflow?: boolean): Promise<IParticipant[]> {
		return await this.listParticipants$(projectID, extendWorkflow).toPromise();
	}

	getParticipant$(projectID: number|string, participantID: number|string): Observable<IParticipant> {
		const url = `${environment.serverEndpoint}/api/projects/${projectID}/participants/${participantID}`;
		return this.httpClient.get<IParticipant>(url);
	}

	async getParticipant(projectID: number|string, participantID: number|string): Promise<IParticipant> {
		return await this.getParticipant$(projectID, participantID).toPromise();
	}

	prepareParticipant$(projectID: string, participant?: IParticipant): Observable<IParticipant> {
		const url = `${environment.serverEndpoint}/api/projects/${projectID}/participants/prepare`;
		return this.httpClient.post<IParticipant>(url, participant);
	}

	createParticipant$(projectID: number|string, participant: IParticipant): Observable<IParticipant> {
		const url = `${environment.serverEndpoint}/api/projects/${projectID}/participants`;
		return this.httpClient.post<IParticipant>(url, participant);
	}

	async createParticipant(projectID: number|string, participant: IParticipant): Promise<IParticipant> {
		return await this.createParticipant$(projectID, participant).toPromise();
	}

	updateParticipant$(projectID: number|string, participant: IParticipant): Observable<IParticipant> {
		const url = `${environment.serverEndpoint}/api/projects/${projectID}/participants/${participant.id}`;
		return this.httpClient.put<IParticipant>(url, participant);
	}

	async updateParticipant(projectID: number|string, participant: IParticipant): Promise<IParticipant> {
		return await this.updateParticipant$(projectID, participant).toPromise();
	}

	deleteParticipant$(projectID: number|string, participant: IParticipant): Observable<void> {
		const url = `${environment.serverEndpoint}/api/projects/${projectID}/participants/${participant.id}`;
		return this.httpClient.delete<void>(url);
	}

	async deleteParticipant(projectID: number|string, participant: IParticipant): Promise<void> {
		return await this.deleteParticipant$(projectID, participant).toPromise();
	}

	searchAll(projectID: string, searchString: string, isProtectedSearch: boolean): Observable<IParticipant[]> {
		const payload = {searchString: searchString};
		const url = `${environment.serverEndpoint}/api/projects/${projectID}/search/${isProtectedSearch ? 'protected' : 'open'}`;
		return this.httpClient.post<IParticipant[]>(url, payload);
	}
}
